import i18n from "i18next"; // Add this import
import { initReactI18next } from "react-i18next";
import en from "./en";
import fi from "./fi";

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: en,
        },
        fi: {
            translation: fi,
        },
    },
    lng: "fi",
    keySeparator: false,
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
